import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import artistDetailsReducer from '../reducers/artistDetailsReducer';

const configureStore = (railsProps) => (
  createStore(artistDetailsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
